import { NavLink } from "react-router-dom";
import { canManageAutomations, canManageLessonBlocks, useAuth } from "../auth.js";

/**
 * Sub-navigation shared by every `/settings/*` page. Accessibility is offered to
 * all staff; the booking-settings tabs follow the account's capabilities, which
 * the server decides.
 */
export function SettingsTabs() {
  const { me } = useAuth();

  return (
    <nav className="row settings-tabs admin-section-tabs" aria-label="Settings sections">
      <NavLink to="/settings/accessibility">Accessibility</NavLink>
      {canManageLessonBlocks(me) ? (
        <NavLink to="/settings/lesson-blocks">Lesson blocks</NavLink>
      ) : null}
      {canManageAutomations(me) ? (
        <NavLink to="/settings/automations">Automations</NavLink>
      ) : null}
    </nav>
  );
}
